import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../helpers/Records';
import { construct, fields, resolve } from '../../../helpers/LinkMapper';

import Cost from './Cost';
import DiscountInfo from './DiscountInfo';

const fieldSchema = {
    weekday: [ resolve.as(Cost) ],
    saturday: [ resolve.as(Cost) ],
    weekly: [ resolve.as(Cost) ],
    monthly: [ resolve.as(Cost) ],
    discountInfo: [ resolve.as(DiscountInfo) ],
    isIncomplete: [ fields.boolean ],
    isChild: [ fields.boolean ],
    isFirstClass: [ fields.boolean ]
};

class CalculationBreakdown extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(CalculationBreakdown, json, getResolvers(fieldSchema));
    }
}

export default CalculationBreakdown;



// WEBPACK FOOTER //
// ./src/records/refund/itso/CalculationBreakdown.js